import { Component, Input } from '@angular/core'
import { IHandlerOperation } from 'src/app/models/HandlerOperation'
import { EvaluationResult, HandlerOperations, RiskAssessment } from 'src/app/models/Reports'

@Component({
	selector: 'app-evaluation-result',
	templateUrl: './evaluation-result.component.html'
})
export class EvaluationResultComponent {
		@Input() public evaluationResult: EvaluationResult = new EvaluationResult()
		@Input() public disabled: boolean = true
}
